import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  useListContext,
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  SimpleForm,
  SelectInput,
  TextInput,
  Button,
  EditButton,
  ShowButton,
  SaveButton,
} from 'react-admin';
import { Button as CButton, Box } from '@material-ui/core';
import { ArrowBack, Search } from '@material-ui/icons';

const useStyles = makeStyles({
  imageField: {
    '& img': { width: 80, height: 80, objectFit: 'cover', marginRight: 4 }
  },
  status0: { color: '#f44336' },
  status1: { color: '#ff9800' },
  status2: { color: '#4caf50' },
});

const useTxtData = {
  page: { tableName: '环境问题上报' },
  table: {
    id: 'ID',
    problemType: '问题类型',
    description: '问题描述',
    images: '问题照片',
    longitude: '经度',
    latitude: '纬度',
    address: '地址',
    status: '状态',
    createTime: '上报时间',
    updateTime: '更新时间',
  }
};

const STATUS_CHOICES = [
  { id: 0, name: '待处理' },
  { id: 1, name: '处理中' },
  { id: 2, name: '已处理' },
];

const ProblemTypeChoices = [
  { id: '垃圾堆积', name: '垃圾堆积' },
  { id: '水体污染', name: '水体污染' },
  { id: '违建', name: '违建' },
  { id: '其它', name: '其它' },
];

const StatusField = (props) => {
  const classes = useStyles();
  const record = props.record;
  if (!record) return null;
  const statusMap = { 0: '待处理', 1: '处理中', 2: '已处理' };
  const classMap = { 0: classes.status0, 1: classes.status1, 2: classes.status2 };
  return <span className={classMap[record.Status] || ''}>{statusMap[record.Status] || record.Status}</span>;
};

const AddressField = (props) => {
  const record = props.record;
  if (!record || !record.Longitude || !record.Latitude) return <span>-</span>;
  // const url = `https://uri.amap.com/navigation?to=${record.Longitude},${record.Latitude}&callnative=0`;
  const url = `https://www.amap.com/regeo?lat=${record.Latitude}&lng=${record.Longitude}&name=&adcode=`
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {record.Longitude}, {record.Latitude}
    </a>
  );
};

const ImagesField = (props) => {
  const classes = useStyles();
  const record = props.record;
  if (!record || !record.Images) return null;
  const images = record.Images.split(',').filter(Boolean);
  if (images.length === 0) return null;
  return (
    <div className={classes.imageField}>
      {images.map((img, idx) => (
        <img key={idx} src={img} alt={`照片${idx + 1}`} />
      ))}
    </div>
  );
};

const Filters = (props) => {
  const { displayedFilters, filterValues, setFilters } = useListContext();
  const onSubmit = values => {
    if (Object.keys(values).length > 0) { setFilters(values); }
    else { setFilters({}, []); }
  };
  return (
    <Filter {...props} onSubmit={onSubmit}>
      <TextInput label="问题类型" source="problemType" alwaysOn resettable />
      <SelectInput label="状态" source="status" choices={STATUS_CHOICES} alwaysOn resettable />
    </Filter>
  );
};

const RowAction = (props) => {
  return (
    <div style={{ textAlign: 'right' }}>
      <EditButton {...props} /><br />
      <ShowButton {...props} /><br />
      <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该上报记录吗？" />
    </div>
  );
};

export const EnvironmentReportList = (props) => {
  const classes = useStyles();
  return (
    <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'CreateTime', order: 'DESC' }} filters={<Filters />}>
      <Datagrid>
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.problemType} source="ProblemType" />
        <TextField label={useTxtData.table.description} source="Description" />
        <ImagesField label={useTxtData.table.images} source="Images" />
        <AddressField label={useTxtData.table.address} source="Address" />
        <StatusField label={useTxtData.table.status} source="Status" />
        <DateField label={useTxtData.table.createTime} source="CreateTime" showTime />
        <RowAction />
      </Datagrid>
    </List>
  );
};

export const EnvironmentReportShow = (props) => {
  const ShowActions = (props) => {
    const { basePath } = props;
    const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
        <EditButton basePath={basePath} record={props.data} />
      </TopToolbar>
    );
  };

  const classes = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
      <SimpleShowLayout>
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.problemType} source="problemType" />
        <TextField label={useTxtData.table.description} source="description" />
        <div label={useTxtData.table.images}>
          <ImagesField source="Images" />
        </div>
        <TextField label={useTxtData.table.longitude} source="longitude" />
        <TextField label={useTxtData.table.latitude} source="latitude" />
        <AddressField label={useTxtData.table.address} source="address" />
        <StatusField label={useTxtData.table.status} source="status" />
        <DateField label={useTxtData.table.createTime} source="CreateTime" showTime />
        <DateField label={useTxtData.table.updateTime} source="UpdateTime" showTime />
      </SimpleShowLayout>
    </Show>
  );
};

export const EnvironmentReportEdit = (props) => {
  const PostEditActions = (props) => {
    const { basePath } = props;
    const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton />
      </Toolbar>
    );
  };

  return (
    <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostEditActions />}>
      <SimpleForm toolbar={<PostEditToolbar />}>
        <TextField label={useTxtData.table.id} source="id" disabled />
        <TextField label={useTxtData.table.problemType} source="problemType" disabled />
        <TextField label={useTxtData.table.description} source="description" disabled />
        <div label={useTxtData.table.images}>
          <ImagesField source="Images" />
        </div>
        <TextField label={useTxtData.table.longitude} source="longitude" disabled />
        <TextField label={useTxtData.table.latitude} source="latitude" disabled />
        <AddressField source="address" />
        <SelectInput label={useTxtData.table.status} source="status" choices={STATUS_CHOICES} />
        <DateField label={useTxtData.table.createTime} source="CreateTime" showTime disabled />
      </SimpleForm>
    </Edit>
  );
};

export const EnvironmentReportCreate = (props) => {
  const PostCreateActions = (props) => {
    const { basePath } = props;
    const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = (props) => {
    const { basePath } = props;
    return (
      <Toolbar {...props}>
        <SaveButton label="保存&列表" redirect={basePath} submitOnEnter={true} />
        <SaveButton label="保存&继续" redirect={false} submitOnEnter={false} variant="text" />
      </Toolbar>
    );
  };

  return (
    <Create title={'新增' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostCreateActions />}>
      <SimpleForm toolbar={<PostCreateToolbar />}>
        <SelectInput label={useTxtData.table.problemType} source="problemType" choices={ProblemTypeChoices} validate={[]} />
        <TextInput label={useTxtData.table.description} source="description" multiline />
        <TextInput label={useTxtData.table.longitude} source="longitude" />
        <TextInput label={useTxtData.table.latitude} source="latitude" />
        <TextInput label={useTxtData.table.address} source="address" />
      </SimpleForm>
    </Create>
  );
};